import type { ReactNode } from 'react'

export type TooltipPlacement =
  | 'top'
  | 'top-left'
  | 'top-right'
  | 'bottom'
  | 'bottom-left'
  | 'bottom-right'
  | 'left'
  | 'right'

export const TOOLTIP_PLACEMENTS: TooltipPlacement[] = [
  'top',
  'top-left',
  'top-right',
  'bottom',
  'bottom-left',
  'bottom-right',
  'left',
  'right',
]

export const TOOLTIP_PLACEMENT_LABELS: Record<TooltipPlacement, string> = {
  top: 'Top',
  'top-left': 'Top left',
  'top-right': 'Top right',
  bottom: 'Bottom',
  'bottom-left': 'Bottom left',
  'bottom-right': 'Bottom right',
  left: 'Left',
  right: 'Right',
}

export const TOOLTIP_DEFAULT_CONTENT = 'Enter description'

export type TooltipProps = {
  content?: string
  placement?: TooltipPlacement
  children?: ReactNode
  className?: string
  /**
   * Dark-surface appearance. Default tooltip is already a dark gray bubble;
   * darkMode uses a blue-800 elevated surface for contrast on dark UIs.
   */
  darkMode?: boolean
  /** Keeps the tooltip visible for the design-system showcase only. */
  open?: boolean
  /**
   * Render the popup in a body portal with fixed positioning.
   * Use inside overflow-clipped containers (e.g. collapsed Drawer).
   */
  portal?: boolean
}
